import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./PlaceInfo.module.scss";

const PlaceInfo = ({ title, description }) => {
  const placeInfoRef = useRef(null);

  useEffect(() => {
    if (placeInfoRef.current) {
      placeInfoRef.current.scrollTop = 0;
    }
  }, [title, description]);

  return (
    <div ref={placeInfoRef} className={styles.placeInfo}>
      <h2 className={styles.title}>{title}</h2>
      <div
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: `${description}<br /><br/>` }}
      />
    </div>
  );
};

PlaceInfo.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default PlaceInfo;
